import React, { useEffect, useState } from 'react';
import useAsync from '../../hooks/useAsync';
import AdminServices from '../../services/AdminServices';
import ReactApexChart from 'react-apexcharts';
import moment from 'moment';

function DistrictDashboard() {
  const [chartData, setChartData] = useState({
    categories: [],
    series: [],
    seriesTrainer: [],
    seriesApointment: [],
    seriesService: [],
    seriesTopThana: [],
    seriesTopUser: []
  });

  const { data: dashboardData } = useAsync(AdminServices.dashboardDistrictOfficer);
  // const { data: dashboardOldData } = useAsync(AdminServices.dashboardUserOld);
  const { data: topUserData } = useAsync(AdminServices.top5DashboardThanaUser);
  // useEffect(() => {
  //   if (dashboardOldData && dashboardOldData.data) {
  //     const months = Array.from({ length: 12 }, (_, index) => moment().month(index).format('MMM'));
  //     const userCounts = new Array(12).fill(0);
  //     const userCounts2 = new Array(12).fill(0);
  //     const userCounts3 = new Array(12).fill(0);
  //     const userCounts4 = new Array(12).fill(0);

  //     dashboardOldData.data.user?.forEach(user => {
  //       const month = moment(user.createdAt).month();
  //       userCounts[month]++;
  //     });

  //     dashboardOldData.data.trainer?.forEach(user => {
  //       const month = moment(user.createdAt).month();
  //       userCounts2[month]++;
  //     });

  //     dashboardOldData.data.serviceCenters?.forEach(user => {
  //       const month = moment(user.createdAt).month();
  //       userCounts3[month]++;
  //     });

  //     dashboardOldData.data.apointment?.forEach(user => {
  //       const month = moment(user.createdAt).month();
  //       userCounts4[month]++;
  //     });

  //     setChartData(prev => ({
  //       ...prev,
  //       categories: months,
  //       series: [{ name: 'User', data: userCounts }],
  //       seriesTrainer: [{ name: 'Trainer', data: userCounts2 }],
  //       seriesApointment: [{ name: 'Apointment', data: userCounts4 }],
  //       seriesService: [{ name: 'Service Center', data: userCounts3 }],
  //     }));
  //   }
  // }, [dashboardOldData]);

  useEffect(() => {
    if (dashboardData && dashboardData.data) {
      const months = Array.from({ length: 12 }, (_, index) => moment().month(index).format('MMM'));
      const userCounts = new Array(12).fill(0);
      const userCounts2 = new Array(12).fill(0);
      const userCounts3 = new Array(12).fill(0);
      const userCounts4 = new Array(12).fill(0);

      dashboardData.data.user?.forEach(user => {
        const month = moment(user.createdAt).month();
        userCounts[month]++;
      });

      dashboardData.data.trainer?.forEach(user => {
        const month = moment(user.createdAt).month();
        userCounts2[month]++;
      });

      dashboardData.data.serviceCenters?.forEach(user => {
        const month = moment(user.createdAt).month();
        userCounts3[month]++;
      });

      dashboardData.data.apointment?.forEach(user => {
        const month = moment(user.createdAt).month();
        userCounts4[month]++;
      });

      setChartData(prev => ({
        ...prev,
        categories: months,
        series: [{ name: 'User', data: userCounts }],
        seriesTrainer: [{ name: 'Trainer', data: userCounts2 }],
        seriesApointment: [{ name: 'Apointment', data: userCounts4 }],
        seriesService: [{ name: 'Service Center', data: userCounts3 }],
      }));
    }
  }, [dashboardData]);



  useEffect(() => {
    if (topUserData?.data) {
      const userNames = topUserData.data.map(user => user?.userDetails?.name || 'Unknown');
      const profileCounts = topUserData.data.map(user => user?.totalProfiles || 0);

      setChartData(prev => ({
        ...prev,
        seriesTopUser: [{ name: 'Total Profiles', data: profileCounts }],
        categoriesUser: userNames
      }));
    }
  }, [topUserData]);

  const chartOptionsThana = {
    chart: { type: 'bar' },
    plotOptions: { bar: { horizontal: false } },
    dataLabels: { enabled: false },
    xaxis: { categories: chartData.categoriesThana || [],
      labels: {
        style: {
          fontWeight: 'bold'
        }
      }
     },
     yaxis: {
      labels: {
        style: {
          fontWeight: 'bold'
        }
      }
    }
  };

  const chartOptionsUser = {
    chart: { type: 'bar' },
    plotOptions: { bar: { horizontal: false } },
    dataLabels: { enabled: false },
    xaxis: { categories: chartData.categoriesUser || [],
      labels: {
        style: {
          fontWeight: 'bold'
        }
      }
     },
    yaxis: {
      labels: {
        style: {
          fontWeight: 'bold'
        }
      }
    }
  };
  const roleLabelMap = {
    Admin: "Nodal Officer",
    User: "P.S. Head",
    CO: "Circle Head",
  };
  
  const userRole = localStorage.getItem("userRole");
  return (
    <div className="main_container">
      <div className="right_col " role="main">
        <div className="container-box">
          <div className="stats-section-header">
            <i className="fa fa-bar-chart stats-section-header-icon" />
            <span>Statistics</span>
          </div>
          <div className="container-box-inner">
            <div className="row">
              <div className="col-md-4">
                <a href="javascript:void(0)" className="stat-card" style={{ borderLeftColor: '#2563EB' }}>
                  <div className="stat-card-header">
                    <div className="stat-card-icon" style={{ backgroundColor: '#EFF6FF', color: '#2563EB' }}>
                      <i className="fa fa-list" />
                    </div>
                    <span className="stat-card-label">Quantitative Verification</span>
                  </div>
                  <div className="stat-card-body">
                    <span className="stat-card-number">{dashboardData?.data?.totalProfiles}</span>
                    <div className="stat-card-today">
                      <span className="stat-card-today-label">Today</span>
                      <span className="stat-card-today-value">{dashboardData?.data?.todayProfiles}</span>
                    </div>
                  </div>
                </a>
              </div>
              <div className="col-md-4">
                <a href="javascript:void(0)" className="stat-card" style={{ borderLeftColor: '#0EA5E9' }}>
                  <div className="stat-card-header">
                    <div className="stat-card-icon" style={{ backgroundColor: '#F0F9FF', color: '#0EA5E9' }}>
                      <i className="fa fa-check-circle" />
                    </div>
                    <span className="stat-card-label">Quantitative Verified</span>
                  </div>
                  <div className="stat-card-body">
                    <span className="stat-card-number">{dashboardData?.data?.totalVerified}</span>
                    <div className="stat-card-today">
                      <span className="stat-card-today-label">Today</span>
                      <span className="stat-card-today-value">{dashboardData?.data?.todayVerified}</span>
                    </div>
                  </div>
                </a>
              </div>
              <div className="col-md-4">
                <a href="javascript:void(0)" className="stat-card" style={{ borderLeftColor: '#F59E0B' }}>
                  <div className="stat-card-header">
                    <div className="stat-card-icon" style={{ backgroundColor: '#FFFBEB', color: '#F59E0B' }}>
                      <i className="fa fa-clock-o" />
                    </div>
                    <span className="stat-card-label">Quantitative Pending</span>
                  </div>
                  <div className="stat-card-body">
                    <span className="stat-card-number">{dashboardData?.data?.totalUnverified}</span>
                    <div className="stat-card-today">
                      <span className="stat-card-today-label">Today</span>
                      <span className="stat-card-today-value">{dashboardData?.data?.todayUnverified}</span>
                    </div>
                  </div>
                </a>
              </div>
              <div className="col-md-4">
                <a href="javascript:void(0)" className="stat-card" style={{ borderLeftColor: '#10B981' }}>
                  <div className="stat-card-header">
                    <div className="stat-card-icon" style={{ backgroundColor: '#ECFDF5', color: '#10B981' }}>
                      <i className="fa fa-shield" />
                    </div>
                    <span className="stat-card-label">Quantitative Valid</span>
                  </div>
                  <div className="stat-card-body">
                    <span className="stat-card-number">{dashboardData?.data?.totalValid || 0}</span>
                    <div className="stat-card-today">
                      <span className="stat-card-today-label">Today</span>
                      <span className="stat-card-today-value">{dashboardData?.data?.todayValid || 0}</span>
                    </div>
                  </div>
                </a>
              </div>
              <div className="col-md-4">
                <a href="javascript:void(0)" className="stat-card" style={{ borderLeftColor: '#EF4444' }}>
                  <div className="stat-card-header">
                    <div className="stat-card-icon" style={{ backgroundColor: '#FEF2F2', color: '#EF4444' }}>
                      <i className="fa fa-times-circle" />
                    </div>
                    <span className="stat-card-label">Quantitative Invalid</span>
                  </div>
                  <div className="stat-card-body">
                    <span className="stat-card-number">{dashboardData?.data?.totalInvalid || 0}</span>
                    <div className="stat-card-today">
                      <span className="stat-card-today-label">Today</span>
                      <span className="stat-card-today-value">{dashboardData?.data?.todayInvalid || 0}</span>
                    </div>
                  </div>
                </a>
              </div>
            </div>
          </div>
          {/* <div className="container-box-inner">
            <div className="row">
              <div className="col-md-4">
                <div className="g-box g-box1">
                  <a href="javascript:void(0)">
                    <p>Total Old Verification
                    </p><h4>{dashboardOldData?.data?.totalProfiles}</h4>
                    <p>Today's Old verification
                    </p>
                    <div className="g-box-inner">
                      <h4>{dashboardOldData?.data?.todayProfiles}</h4>
                      <img src="img/total-customer.svg" alt="" />
                    </div>
                  </a>
                </div>
              </div>
              <div className="col-md-4">
                <div className="g-box g-box7">
                  <a href="javascript:void(0)">
                    <p>Total Old Verified</p>   <h4>{dashboardOldData?.data?.totalVerified}</h4>
                    <p>Today's Old Verified</p>
                    <div className="g-box-inner">
                      <h4>{dashboardOldData?.data?.todayVerified}</h4>
                      <img src="img/query.svg" alt="" />
                    </div>
                  </a>
                </div>
              </div>
              <div className="col-md-4">
                <div className="g-box g-box2">
                  <a href="javascript:void(0)">
                    <p>Total Pending Old Verification</p>  <h4>{dashboardOldData?.data?.totalUnverified}</h4>
                    <p>Today's Pending Old Verification</p>
                    <div className="g-box-inner">
                      <h4>{dashboardOldData?.data?.todayUnverified}</h4>
                      <img src="img/query.svg" alt="" />
                    </div>
                  </a>
                </div>
              </div>
            
            </div>
          </div> */}
        </div>
         
        {/* <div className="container-box">
          <p><strong>Top Performing App User</strong>
          </p>
          <ReactApexChart options={chartOptionsUser} series={chartData.seriesTopUser} type="bar" height={350} />
        </div> */}
      </div>
    </div>
  );
}

export default DistrictDashboard;
